/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_GapInputs */

const en_ui_chart_series_gap = /** @type {(inputs: Ui_Chart_Series_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAP`)
};

const de_ui_chart_series_gap = /** @type {(inputs: Ui_Chart_Series_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAP`)
};

/**
* | output |
* | --- |
* | "GAP" |
*
* @param {Ui_Chart_Series_GapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_gap = /** @type {((inputs?: Ui_Chart_Series_GapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_GapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_gap(inputs)
	return de_ui_chart_series_gap(inputs)
});